import { Component, OnInit, ViewChild } from '@angular/core';
import { E5coreUiWorkCasenotesBaseComponent } from './e5core-ui-work-casenotes-base';
import { PageEvent, MatSort, MatPaginator } from '@angular/material';
import { CasenotesOdataService } from '../../../services/casenotes-odata.service';
import { Guid } from 'guid-typescript';
import { OdataMatTableDataSource } from './odata-mat-table-data-source';
import { WorkCasenotesFrameModel } from '../../../models/work-casenotes.model';

@Component({
  selector: 'e5core-ui-work-casenotes-material',
  templateUrl: './e5core-ui-work-casenotes-material.component.html',
  styleUrls: ['./e5core-ui-work-casenotes-material.component.css']
})
export class E5coreUiWorkCasenotesMaterialComponent extends E5coreUiWorkCasenotesBaseComponent implements OnInit{

  displayedColumns: string[] = ['CasenoteDate','User','CasenoteType','Detail'];
  dataSource: OdataMatTableDataSource ;
  isLoading: boolean = true ;

  length = 0;
  pageSize = 10;
  pageSizeOptions: number[] ;

  // MatPaginator Output
  pageEvent: PageEvent;
  @ViewChild(MatSort) sort: MatSort;t
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private casenotes : CasenotesOdataService) {
    super() ;
  }

  ngOnInit() {
    this.pageSizeOptions = (this.pagesizes && this.pagesizes.length > 0) ? this.pagesizes : [5, 10, 25, 50];
    this.dataSource = new OdataMatTableDataSource(Guid.EMPTY, this.casenotes); // this.history.getHistory(id, 0, 10) ;
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource.loadingEvents.subscribe(
      isLoading => {
        this.isLoading = isLoading ;
      }
    )

    this.workItem$.subscribe(
      wim => {
        this.dataSource.setWorkId(wim.workId) ;
      }
    )
  }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
  }

}